import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import useGrievanceReportStore from "./store/grievanceReportStore";
const GrievanceDetailedReportModal = ({ show, handleClose, selectedGrievanceData }) => {
    const { fetchgrievanceDetailedReport, updateGrievanceData } = useGrievanceReportStore();
    const [filePreview, setFilePreview] = useState(selectedGrievanceData?.fileUpload || null);
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const initialValues = {
        complaintNo: selectedGrievanceData?.complaintNo || "",
        kpiCategoryName: selectedGrievanceData?.kpiCategoryName || "",
        ieEngineerName: selectedGrievanceData?.ieEngineerName || "",
        fileUpload: null,
        contactNumber: selectedGrievanceData?.contactNumber || "",
        description: selectedGrievanceData?.description || "",
        status: selectedGrievanceData?.status || '',
    };


    // Form validation schema
    const validationSchema = Yup.object().shape({
        status: Yup.string().required("Status is required"),
        // file: Yup.string().required("File is required"),
    });



    const handleSubmit = async (values, { resetForm, setErrors }) => {

        try {
            const payload = {
                id: selectedGrievanceData?.complaintNo || null,
                status: values.status || null
            };

            let result;
            // if (selectedGrievanceData?.engineerId) {
                setLoading(true)
            // Update existing engineer
            result = await updateGrievanceData(payload);
            // } 
            console.log(result)

            if (result.success) {
                resetForm();
                fetchgrievanceDetailedReport();
                handleClose();
                setLoading(false)
            } else if (result.errors) {
                setErrors(result.errors); 
                setLoading(false)
            }
        } catch (error) {
            console.error("Submission failed:", error);
            setLoading(false)
            setErrors({ general: "Something went wrong. Please try again." });
        }
    };



    return (
        <Modal show={show} onHide={handleClose} centered size="lg">
            <Modal.Header >
                <Modal.Title className="fw-bold"> {selectedGrievanceData ? "Edit Grievance" : "Edit Grievance"}</Modal.Title>
                <i
                    class="fa-solid fa-xmark close-container"
                    onClick={handleClose}
                ></i>
            </Modal.Header>
            <hr />
            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                {({ values, handleChange, setFieldValue }) => (
                    <Form>
                        <Modal.Body>
                            <div className="row">
                                <div className="col-md-4 mb-3">
                                    <label className="fw-semibold">Complaint Number</label>
                                    <Field type="text" name="complaintNo" disabled className="form-control" placeholder="Enter Complaint Number"
                                    />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label className="fw-semibold">IE Engineer Name</label>
                                    <Field type="text" name="ieEngineerName" disabled className="form-control" placeholder="Enter IE Engineer Name"
                                    />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <label className="fw-semibold">KPI</label>
                                    <Field type="text" name="kpiCategoryName" disabled className="form-control" placeholder="Enter KPI"
                                    />
                                </div>

                            </div>

                            <div className="row">
                                <div className="mb-3 col-md-4 mb-3">
                                    <label className="fw-semibold">Status</label>
                                    <Field as="select" name="status" className="form-select">
                                        {/* <option value="">Select Status</option>
                                        <option value="Open">Open</option> */}
                                        {selectedGrievanceData?.status === "Open" && (
                                            <>
                                                <option value="Open">Open</option>
                                                <option value="Closed">Close</option>
                                            </>
                                        )}
                                        {selectedGrievanceData?.status === "Closed" && (
                                            <>
                                                <option value="Closed">Close</option>
                                                <option value="Reopen">Reopen</option>
                                            </>
                                        )}
                                        {selectedGrievanceData?.status === "Reopen" && (
                                            <>

                                                <option value="Reopen">Reopen</option>
                                                <option value="Closed">Close</option>
                                            </>
                                        )}


                                    </Field>
                                    <ErrorMessage name="status" component="div" className="text-danger mt-1" />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label className="fw-semibold">File (Image/PDF)</label>

                                    {selectedGrievanceData?.fileUpload && !filePreview && (
                                        <div className="mt-2">
                                            {selectedGrievanceData.fileUpload.endsWith(".pdf") ? (
                                                <a href={selectedGrievanceData.fileUpload} target="_blank" rel="noopener noreferrer">
                                                    View Existing PDF
                                                </a>
                                            ) : (
                                                <img src={selectedGrievanceData.fileUpload} alt="Existing File" style={{ width: "100px", height: "100px", borderRadius: "5px" }} />
                                            )}
                                        </div>
                                    )}
                                </div>

                            </div>

                            <div className="mb-3 ">
                                <label className="fw-semibold">Description</label>
                                <Field
                                    as="textarea"
                                    name="description"
                                    disabled
                                    className="form-control"
                                    placeholder="Enter Description"

                                />
                            </div>
                        </Modal.Body>

                        <div className="modal-footer d-flex justify-content-center">
                            {/* {canWrite === true ? ( */}
                            <button
                                type="submit"
                                className="deployment-button"
                            // disabled={isSubmit}
                            >
                                {selectedGrievanceData ?
                                    loading ?
                                        <l-bouncy
                                            size="25"
                                            speed="1.75"
                                            color="white"
                                        ></l-bouncy> : <> <i className="fa-solid fa-check done-container"></i> Update</> :
                                    loading ? <l-bouncy
                                        size="25"
                                        speed="1.75"
                                        color="white"
                                    ></l-bouncy> : <> <i className="fa-solid fa-check done-container"></i> Submit </>}

                            </button>

                        </div>

                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default GrievanceDetailedReportModal;
